(function (module) {
    'use strict';

    function AdminViewAccountCtrl(Account, $stateParams, Includes, Store, $state, $rootScope, utils) {
        this.$onInit = () => {
            Account
                .findById({ id: $stateParams.accountId, filter: Includes.accounts })
                .$promise
                .then((response) => {
                    this.account = Store.setSingleModelData('accounts', response.id, response);
                });
            this.selectedIndex = $rootScope.selectedIndex;
            this.currentUser = Store.getCurrentUser();

        };
        this.cancel = () => {
            $state.go('root.admin.accounts');
        };
        this.addUser = () => {
            $rootScope.selectedIndex = 1;
            $state.go('root.admin.accounts.view.adduser');
        };
        this.inviteUser = () => {
            $rootScope.selectedIndex = 1;
            $state.go('root.admin.accounts.view.inviteuser');
        };
        this.goBack = () => {
            $rootScope.selectedIndex = 0;
            $state.go('root.admin.accounts');
        };
        this.checkType = () => {
            if (this.account.type === 'paid') {
                this.account.startDate = new Date();
            }
            if (this.account.type === 'free') {
                this.account.startDate = null;
            }
        };

        this.saveAccount = () => {
            $rootScope.selectedIndex = 0;
            Account
                .prototype$patchAttributes(
                    { id: this.account.id },
                    {
                        name: this.account.name,
                        address1: this.account.address1,
                        address2: this.account.address2,
                        postcode: this.account.postcode,
                        country: this.account.country,
                        type: this.account.type,
                        trialPeriod: this.account.trialPeriod,
                        accountVerified: this.account.accountVerified,
                        enabled: this.account.enabled,
                        beta: this.account.beta,
                        customApps: this.account.customApps,
                        codePinPairing: this.account.codePinPairing,
                        subscriptions: this.account.subscriptions,
                        startDate: this.account.startDate,

                    },
                )
                .$promise
                .then(() => {
                    return Account.findById({
                        id: this.account.id,
                        filter: Includes.accounts,
                    }).$promise;
                })
                .then((account) => {
                    return Store.setSingleModelData('accounts', this.account.id, account);
                })
                .then(() => {
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });

        };

    }

    module
        .component('adminViewAccountComponent', {
            templateUrl: '/js/admin/accounts/view-account/view-account.html',
            controller: AdminViewAccountCtrl,
        })
        .config(($stateProvider) => {
                $stateProvider
                    .state('root.admin.accounts.view', {
                        url: '/:accountId',
                        data: {
                            pageTitle: 'ADMIN_ACCOUNTS_VIEW.PAGE_TITLE',
                        },
                        views: {
                            'content@root': {
                                template: '<admin-view-account-component />',
                            },
                        },
                    });
            },
        );

})(angular.module('rocket.components'));
